<div class="success-container">
  <div class="success-card">
    <!-- Icono de éxito animado -->
    <div class="success-icon-wrapper">
      <mat-icon class="success-icon">check_circle</mat-icon>
    </div>

    <!-- Título principal -->
    <h1 class="success-title">{{ 'SUBSCRIPTION_SUCCESS.TITLE' | translate }}</h1>
    
    <!-- Mensaje de agradecimiento -->
    <p class="success-message">
      {{ 'SUBSCRIPTION_SUCCESS.MESSAGE' | translate }}
    </p>

    <!-- Información de la suscripción -->
    <div class="subscription-info" *ngIf="subscriptionInfo">
      <div class="info-card">
        <mat-icon class="info-icon">{{ subscriptionInfo.icon }}</mat-icon>
        <div class="info-content">
          <h3 class="info-title">{{ subscriptionInfo.name | translate }}</h3>
          <p class="info-description">{{ subscriptionInfo.description | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
